import { render, staticRenderFns } from "./UserSettingsReports.vue?vue&type=template&id=17426e37"
import script from "./UserSettingsReports.vue?vue&type=script&lang=js"
export * from "./UserSettingsReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports